import { Controller } from "@hotwired/stimulus"

// Авто-submit формы по вводу с debounce.
// delayValue — задержка в мс (по умолчанию 300).
// Использование: data-controller="debounced-submit"
//                data-action="input->debounced-submit#submit"
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.form.requestSubmit()
    }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
